<template>
<div class="chapter">
<div class="inner_page">
<p class="ct2"><a id="page_vii">Praise for John A. Daly and <i>From a Dead Sleep</i></a></p><a id="page_vii">
<p class="tx1">Some writers are thoughtful. Some have style. John Daly has both. When I read his work, it’s time well spent.</p>
<p class="txr"><b>— Bernard Goldberg, <i>New York Times</i> bestselling author of <i>Bias</i></b></p>
<p class="tx1-1">An epic thriller with a memorable, unorthodox main character . . . a riveting read . . .</p>
<p class="txr"><b><i>— Colorado Country Life Magazine</i></b></p>
<p class="tx1-1">A fast-reading suspense book that surprised me so much, I had to finish it in one sitting.</p>
<p class="txr"><b>— Alice de Sturler of the American Investigative Society of Cold Cases</b></p>
<p class="tx1-1">A thriller that packs a punch! This was a very exciting debut novel from John A. Daly. This novel packs a lot of jaw-dropping action into its well-structured narrative—a narrative that gives life to the myriad of characters that inhabit its pages and provides plenty of plot twists and turns to keep you glued to the pages.</p>
<p class="txr"><b>— Reading, Writing, and Riesling book blog</b></p>
<p class="tx1-1">I loved this book. The suspense had me sitting on the edge of my seat . . . The author did a fabulous job with the setting details—I could picture every touch, smell, sight that the characters went through . . .</p>
<p class="txr"><b>— Yawatta Hosby, author of the novel <i>One by One</i></b></p>
<p class="tx1-1"><i>From a Dead Sleep</i> is a page-turner, an exciting, well-written thriller with a solid back story and more than enough plot twists to keep you guessing.</p>
<p class="txr"><b>— Marilyn Armstrong, Serendipity book blog</b></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter03.vue?4d22f69b